import {
    Backdrop,
    Box,
    Card,
    LinearProgress,
    Paper,
    Typography,
} from "@mui/material";

export default function BankConnectProgress({}) {
    return (
        <Box>
            <Backdrop
                sx={{
                    color: "#fff",
                    backgroundColor: "rgb(0 0 0 / 80%)",
                    zIndex: 99999999,
                }}
                open={true}
                // onClick={handleClose}
            >
                <Paper
                    sx={{
                        minWidth: "300px",
                        minHeight: "200px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "10px",
                    }}
                >
                    <Typography sx={{ padding: "0 10px" }}>
                        درحال اتصال به بانک ، لطفا منتظر بمانید ...
                    </Typography>
                    <Box sx={{ width: "100%", marginTop: "20px" }}>
                        <LinearProgress />
                    </Box>
                </Paper>
            </Backdrop>
        </Box>
    );
}
